import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ReactiveFormsModule } from '@angular/forms';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { AdminService } from '../../../../../services/administrator/admin.service';
import { MaterialModule } from '../../../../../shared/module/material.module';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms'
import { SharedServices } from '../../../../../shared/services/shared.services';

export function chevronEmailValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const sEmail = control.value;
    if (!sEmail) {
      return null; 
    }

    const str = sEmail.toUpperCase();
    if (str.indexOf("@CHEVRONTEXACO.COM") <= 0 && str.indexOf("@CHEVRON.COM") <= 0) {
      return { invalidChevronEmail: true };
    } else if ((str.indexOf(".COM") + 4) !== str.length) {
      return { invalidEmail: true };
    }

    return null; 
  };
}
@Component({
  selector: 'app-add-update-dialog',
  imports: [MaterialModule, ReactiveFormsModule, CommonModule],
  templateUrl: './add-update-dialog.component.html',
  styleUrl: './add-update-dialog.component.css'
})
export class AddUpdateDialogComponent {
  NonCNLEmpForm: FormGroup;
  isDeveloper: boolean = false;
  isLoading: boolean = false;

  constructor(
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AddUpdateDialogComponent>,
    private http: HttpClient,
    private adminService: AdminService,
    private sharedService: SharedServices
  ) {
    this.NonCNLEmpForm = this.fb.group({
      id: [data.user?.id || null],
      employeeNo: [{ value: data.user?.employeeno || '', disabled: data.isEdit },[Validators.required,Validators.maxLength(5)]],
      cai: [{ value: data.user?.cai || '', disabled: data.isEdit }],
      surname: [data.user?.surname || '', [Validators.required,Validators.maxLength(50)]],
      firstname: [data.user?.firstname || '', [Validators.required,Validators.maxLength(50)]],
      middlename: [data.user?.middlename || '', Validators.maxLength(50)],
      initials: [data.user?.initials || '', [Validators.required,Validators.maxLength(10)]],
      jobtitle: [data.user?.jobtitle || '',Validators.maxLength(100)],
      reportsToCai: [data.user?.reportstocai || '',Validators.maxLength(10)],
      emailAddress: [{ value: data.user?.emailaddress || '', disabled: data.isEdit }, 
      [Validators.email, chevronEmailValidator(),Validators.maxLength(100)]],
      costCenter: [data.user?.costCenter || '',Validators.maxLength(10)],
      deptname: [data.user?.deptname || '',Validators.maxLength(50)],
    });
  }

  ngOnInit(): void {
    if (this.data.isEdit) {
      this.NonCNLEmpForm.patchValue(this.data.user);
      this.data.initialValues = this.NonCNLEmpForm.getRawValue();
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    this.isLoading = true;
    if (this.NonCNLEmpForm.invalid) {
      this.sharedService.openModal('Message', 'Please enter all required information');
      this.isLoading = false;
      return;
    }
  
    if (this.data.isEdit) {
      const updatedNonCNLEmp = this.NonCNLEmpForm.getRawValue();
      if (JSON.stringify(this.data.initialValues) === JSON.stringify(updatedNonCNLEmp)) {
        this.sharedService.openModal('Message', 'No changes detected');
        this.isLoading = false;
        return;
      }
      this.adminService.updateNonCNLEmployee(updatedNonCNLEmp).subscribe({
        next: response => {
          this.dialogRef.close(response);
          this.isLoading = false;
          this.sharedService.openModal('Message', 'Updated Successfully');
        },
        error: error => {
          console.error('Error updating noncnlemp', error);
          this.isLoading = false;
        }
      });
    } else {
      const employeeNo = this.NonCNLEmpForm.get('employeeNo')?.value;
      const employeeExists = this.data.existingEmployees.some((emp: any) => emp.employeeno === employeeNo);
  
      if (employeeExists) {
        this.sharedService.openModal('Message', 'Employee already exists');
        this.isLoading = false;
      } else {
        this.adminService.addNonCNLEmployee(this.NonCNLEmpForm.value).subscribe({
          next: response => {
            this.dialogRef.close(true);
            this.isLoading = false;
            this.sharedService.openModal('Message', 'Added Successfully');
          },
          error: error => {
            console.error('Error adding noncnlemp', error);
            this.isLoading = false;
          }
        });
      }
    }
  }
}